'use strict';

const windowOrGlobal = require('window-or-global');
const memoryStore = require('localstorage-memory');

module.exports = () => {
    return windowOrGlobal.localStorage || memoryStore;
}
